export const updateHistoryState = (searchParamsString: string): void => {
  const fullSearchParamsString = searchParamsString ? `?${searchParamsString}` : '';
  const newPathWithSearch = `${window.location.pathname}${fullSearchParamsString}`;
  window.history.replaceState(null, '', newPathWithSearch);
};
